import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
/**
 * Generated class for the AvatalistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-avatalist',
  templateUrl: 'avatalist.html',
})
export class AvatalistPage {
@ViewChild('elementID') elementID:ElementRef;

    segment: string = 'one';

	loginId: string;
	email: string;
    api_key: string;
    version: string;

	tab: any = [];
	list_one: any = [];
	list_two: any = [];
	list_two_accordian: any = [];
	list_three_accordian: any = [];
    // params: any[] = [];
    // count: number = 0;
    // max_length: number = 0;
    
	six: string = 'N';
	coin_unit: string;
	bonus_unit: string;
	unit: string;
	cash_room_unit: string;
	bonus_room_unit: string;

    list_date: string;
    
    balance: any = [];
    button: any = [];
    // balance_usdt: string;
	texts: any = [];
    language : string;

    checked: boolean = false;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
        // private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {
		
	}

    ngOnlnit() {
        this._init();
    }

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "withdrawalcoinlist");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.unit = localStorage.getItem("unit");
		// this.cash_room_unit = localStorage.getItem("cash_room_unit");
		// this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).avatalist;
	}

    // _toggleFunc(index) {
    //     let hasclass = document.getElementById('opened'+index).classList.contains('active');
    //     if (hasclass) {
    //         this.checked = false;
    //         document.getElementById('opened'+index).classList.remove('active');
    //     } else {
    //         this.checked = true;
    //         document.getElementById('opened'+index).classList.add('active');
    //     }
    // }

    // _accordian_list(data) {
    //     // // .checked 클래스를 가진 모든 요소에서 'active' 클래스를 제거
    //     // document.querySelectorAll('.checked').forEach(element => {
    //     //     element.classList.remove('active');
    //     // });

    //     // // .opened 클래스를 가진 모든 요소에서 'active' 클래스를 제거
    //     // document.querySelectorAll('.opened').forEach(element => {
    //     //     element.classList.remove('active');
    //     // });

        
    //     let hasId_opened = document.getElementById('opened'+data.index).classList.contains('active');
    //     let hasId_checked = document.getElementById('checked'+data.index).classList.contains('active');

    //     // const element: HTMLElement | null = document.querySelector('.checked');

    //     // element.addEventListener('click', function(this: HTMLElement) {
    //     //     this.classList.remove('active');
    //     // });

    //     if (hasId_opened) {
    //         // this.checked = false;
    //         document.getElementById('opened'+data.index).classList.remove('active');
    //         document.getElementById('checked'+data.index).classList.remove('active');
    //     } else {
    //         // this.checked = true;

    //         Array.from(document.querySelectorAll('.checked')).forEach(element => {
    //             element.classList.remove('active');
    //         });

    //         Array.from(document.querySelectorAll('.opened')).forEach(element => {
    //             element.classList.remove('active');
    //         });

    //         document.getElementById('opened'+data.index).classList.add('active');
    //         document.getElementById('checked'+data.index).classList.add('active');
    //     }
        
    //     if (!hasId_checked) {
    //         this.list_two_accordian = [];
    //         this.list_three_accordian = [];

    //         let url = "bonus/base/index/detail";
    //         let body = JSON.stringify({ 
    //             api: this.api_key,
    //             language: this.language,
    //             version: this.version,
    //             tab: data.tab,
    //             date: data.date,
    //             code: data.code
    //         });
    //         this.http.post(url, body).then((res: any) => {
    //             if(res.result=="OK"){

    //                 if (res.list != undefined) {
    //                     if (data.tab == 'two'){
    //                         this.list_two_accordian = res.list;
    //                         this.list_date = data.date;
    //                     }
    //                     if (data.tab == 'three'){
    //                         this.list_three_accordian = res.list;
    //                         this.list_date = data.date;
    //                     }
    //                 }

    //             } else if(res.result ==="DONOT"){
    //                 let alert = this.alertCtrl.create({
    //                     message: res.message,
    //                     buttons: ['OK']
    //                 });
    //                 alert.present();
    //                 // this.navCtrl.pop();

    //             } else if(res.result ==="LOGOUT"){
    //                 let alert = this.alertCtrl.create({
    //                     message: res.message,
    //                     buttons: ['OK']
    //                 });
    //                 alert.present();
    //                 localStorage.removeItem("loginId");
    //                 localStorage.removeItem("api_key");
    //                 this.app.getRootNav().setRoot(LoginPage);
                
    //             } else {
    //                 // this.navCtrl.pop();
    //                 let alert = this.alertCtrl.create({
    //                     message: res.message,
    //                     buttons: ['OK']
    //                 });
    //                 alert.present();
    //             }
    //         },(err)=>{
    //             let alert = this.alertCtrl.create({
    //                 message: this.texts.alertM_err,
    //                 buttons: ['OK']
    //             });
    //             alert.present();
    //         });
    //     }
        
    // }

	_init() {		
		this.list_one = [];
		this.list_two = [];
		
        let url = "coin/base";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.tab = res.tab;
                this.balance = res.balance;
                this.coin_unit = res.coin_unit;

                // let list: any;
                // let opened_i: string;
                // let opened_i_obj: any;
                // let checked_i: string;
                // let checked_i_obj: any;

                if (res.list != undefined) {
                    if (this.segment == 'one') {
                        if(res.list.one != undefined) {
                            this.list_one = res.list.one;
                        }

                    }

                    if (this.segment == 'two') {
                        if(res.list.two != undefined) {
                            this.list_two = res.list.two;
                        }

                    }

                    // if (this.segment == 'two') {
                    //     if(res.list.two != undefined) {
                    //         // this.list_two = res.list.two;
    
                    //         let list_two = res.list.two;
                    //         let list_two_length = res.list.two.length;
                        
                    //         for (let i = 0; i < list_two_length; i++) {
                    //             list = list_two[i];
    
                    //             opened_i = 'opened'+i;                           
                    //             opened_i_obj = {opened_i : opened_i};
                                                    
                    //             list_two[i] = Object.assign(list, opened_i_obj);

                    //             checked_i = 'checked'+i;                           
                    //             checked_i_obj = {checked_i : checked_i};
                                                    
                    //             list_two[i] = Object.assign(list, opened_i_obj, checked_i_obj);
                    //         }
                    //         this.list_two = list_two;
                    //     }

                    // }

                    // if (this.segment == 'three') {
                    //     if(res.list.three != undefined) {
                    //         // this.list_three = res.list.three;
    
                    //         let list_three = res.list.three;
                    //         let list_three_length = res.list.three.length;
                        
                    //         for (let i = 0; i < list_three_length; i++) {
                    //             list = list_three[i];
    
                    //             opened_i = 'opened'+i;                           
                    //             opened_i_obj = {opened_i : opened_i};
                                                    
                    //             list_three[i] = Object.assign(list, opened_i_obj);

                    //             checked_i = 'checked'+i;                           
                    //             checked_i_obj = {checked_i : checked_i};
                                                    
                    //             list_three[i] = Object.assign(list, opened_i_obj, checked_i_obj);
                    //         }
                    //         this.list_three = list_three;
                    //     }
                        
                    // }
                }
				
				// if(res.list != undefined) {
				// 	this.list = res.list;
				// 	this.max_length = res.list.length;
				// 	this.params = [];
				// 	this.count = 0;
				// 	for (var i = 0; i < 9; i++) {
				// 		if(this.max_length <= this.count) break;
				// 		this.params.push(this.items[this.count]);
				// 		this.count++;
				// 	}
				// }
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				// this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

}



// WEBPACK FOOTER //
// ./src/pages/avatalist/avatalist.ts